import { api } from "./configs/axiosConfigs"

export const UserAPI = {

  index: async function (cancel = false) {
    const response = await api.request({
      url: "/users",
      method: "GET",
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

  create: async function (data, cancel = false) {
    const response = await api.request({
      url: "/users",
      method: "POST",
      data: data,
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

  verify: async function (id, hash, expires, signature, cancel = false) {
    const response = await api.request({
      url: "/email/verify/" + id,
      method: "GET",
      params: {
        expires: expires,
        hash: hash,
        signature: signature,
      },
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

  assignRole: async function (data, cancel = false) {
    const response = await api.request({
      url: "/roles/assign-role",
      method: "POST",
      data: data,
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

  enableUser: async function (id, cancel = false) {
    const response = await api.request({
      url: "/users/enable-user/" + id,
      method: "GET",
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

  profile: async function (cancel = false) {
    const response = await api.request({
      url: "/users/profile",
      method: "GET",
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },
}
